import { useMutation } from 'react-query';

import { createOrUpdateCard as mutationFn } from 'api/endPoints/createOrUpdateCard';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';

import {
    IExternalLink,
    ITagList,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { CardType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';

export const useMutationCreateCard = () => {
    return useMutation<CardResponse, QueryError, ICreateCardPayload>((params) => mutationFn(params));
};

export interface ICreateCardPayload {
    id: number | null;
    projectId: number;
    contractId: number;
    activityId?: number | null;
    category: string;
    details?: string;
    mentionedList?: string[];
    startDate: number;
    endDate: number;
    externalLinks?: IExternalLink[];
    status: string;
    tagList?: ITagList[];
    title: string;
    relatedCardIds: null;
    type: CardType;
    assigneeUserName?: string;
    isImportant: boolean;
    versionId: number;
}
